import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from './ui/card';
import { Button } from './ui/button';
import { TGetGiftCardsRes } from '@/services/giftCards';
import { cn } from '../lib/utils';
import { TGiftOrDonation } from '@/lib/types';
import { useTranslation } from 'react-i18next';
import { TangoMaxAmount } from '@/lib/constants';

type TGiftCardProps = {
  idx: number;
  brands: TGetGiftCardsRes['catalog'][0]['brands'];
  refundAmount: number;
  type: TGiftOrDonation;
  setSelectedOption: (idx: number) => void;
  setIsOpen: (isOpen: boolean) => void;
};
const GiftCard = ({
  type,
  brands,
  idx,
  setIsOpen,
  setSelectedOption,
  refundAmount,
}: TGiftCardProps) => {
  const { t } = useTranslation();
  const { brandName, imageUrls } = brands[0];

  const capMaxValue = (capAmount: number, tangoMaxAmount: number) => {
    return Math.min(capAmount, tangoMaxAmount);
  };

  const validateRefundAmount = (min: number, max: number, amount: number) => {
    if (amount < min || amount > max) return false;
    return true;
  };

  const isClaimable = validateRefundAmount(
    brands[0].items[0].minValue,
    capMaxValue(TangoMaxAmount, brands[0].items[0].maxValue),
    refundAmount,
  );

  const onClick = () => {
    setSelectedOption(idx);
    setIsOpen(true);
  };

  const buttonLabelByType = {
    giftcards: 'Get Gift Card',
    donations: 'Donate',
    digitalpayments: 'Claim Payment',
  };

  return (
    <>
      <Card
        className={cn(
          'flex w-full flex-col items-start justify-between transition-shadow duration-300 hover:shadow-xl lg:min-h-[255px] lg:w-64',
          !isClaimable ? 'opacity-50' : '',
        )}
      >
        <div className='flex w-full items-center justify-start p-5 md:p-3 lg:flex-col lg:justify-center'>
          <CardHeader className='flex-row items-center justify-center p-0 lg:size-full lg:flex-col'>
            <img src={imageUrls['300w-326ppi']} alt={brandName} />
          </CardHeader>
          <CardContent className='pb-0 lg:pb-6'>
            <CardTitle className='text-center text-lg font-medium lg:text-sm'>
              {brandName}
            </CardTitle>
            <CardDescription className='text-center text-sm lg:text-xs'>
              ({t('Min')} ${brands[0].items[0].minValue} -{t('Max')} $
              {capMaxValue(TangoMaxAmount, brands[0].items[0].maxValue)})
            </CardDescription>
          </CardContent>
        </div>
        <CardFooter className='w-full'>
          <Button
            disabled={!isClaimable}
            variant='outline'
            className='w-full'
            onClick={onClick}
          >
            {t(buttonLabelByType[type])}
          </Button>
        </CardFooter>
      </Card>
    </>
  );
};

export default GiftCard;
